import { render, staticRenderFns } from "./PropostaPessoaEditDocumentos.vue?vue&type=template&id=bbc4c768"
import script from "./PropostaPessoaEditDocumentos.vue?vue&type=script&lang=js"
export * from "./PropostaPessoaEditDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports